import React, { Component } from 'react';
// import * as Sentry from "@sentry/browser";

import Error from './index';
import { Location } from '@reach/router';

class Boundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };
    }

    componentDidCatch = (error, errorInfo) => {
        console.log('ERROR');
        console.log(errorInfo);
        this.setState({ error });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.error && prevProps.location?.pathname !== this.props.location?.pathname) {
            this.setState({ error: null });
        }
    }

    reportFeedback = () => {
        // Sentry.showReportDialog();
    };

    render() {
        if (this.state.error) {
            return <Error error={this.state.error} />;
        }

        return this.props.children;
    }
}

export default props => (
    <Location>{locationContext => <Boundary {...locationContext} {...props} />}</Location>
);
